module.exports = __webpack_public_path__ + "static/media/undraw_Security_re_a2rk.8313cffc.png";